// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"6a132287","20":"38e5954e","201":"9713155b","230":"1d1524fc","235":"e3058136","556":"220f0bc1","578":"22b65bb8","639":"0f04d689","673":"172d9e00","699":"17ada7f1"}[chunkId] + ".chunk.js";
};